/* eslint-disable eqeqeq */
import { Component } from "react";
import { HiDownload, AiOutlineClose, AiOutlineCheck } from "react-icons/all";
import { Feedback } from "../Feedback/Feedback";
import MessageDialog from "../Message/Message";
import { Collapsible } from "../Collapsible/Collapsible";
import {
  ItemClassTotalsEntity,
  AdminChecklistItems,
  AdminChecklist,
  ActionType,
} from "../CommonProps";
import { Common } from "../CommonService";
import Videos from "../Videos/Videos";
import { Box, Button, Heading, SimpleGrid, GridItem } from "@chakra-ui/react";
import { EstimateProps } from "../modals/PropInterface/EstimateProps";
import { EstimateState } from "../modals/StateInterface/EstimateState";
import DialogMessage from "../Dialog/DialogMessage";
import { NotifyService } from "../Services/NotifyService";
import { Mixpanel } from "../Services/MixPanel";
import { CommonMethodService } from "../Services/CommonMethodService";
import { dashboardTabs } from "../modals/Enums/DashboardTabs";
import { Email } from "../modals/Appointment";
import { IBSAdonisService } from "../Services/IBSAdonisService";

require("./estimate.css");
const feedbackSuccess =
  require("./../assets/images/feedbackSuccess.png").default;

export enum itemClass {
  parts = "Parts",
  removeAndRefit = "RemoveAndRefit",
  repair = "Repair",
  mechanical = "Mechanical",
  paint = "Paint",
}

export default class Estimate extends Component<EstimateProps, EstimateState> {
  common = new Common();
  notifyService = new NotifyService();
  commonMethodService = new CommonMethodService();
  private ibsAdonisService = new IBSAdonisService();

  constructor(props: EstimateProps) {
    super(props);
    this.state = {
      showAcceptMessage: false,
      showDeclineMessage: false,
      showFeedbackScreen: false,
      showFeedbackSuccessMessage: false,
      createNewCustomerInStamped: this.props.isOwnerSubscribed,
      videos: [
        {
          type: "Wheel Repair",
          link: "https://www.youtube-nocookie.com/embed/Lzr8WxaNXjM",
        },
        {
          type: "Vehicle Repair",
          link: "https://www.youtube.com/embed/rfzgnHIJWIY",
        },
      ],
    };
  }

  componentDidMount() {
    Mixpanel.track("User navigated to estimate tab", {
      action: "User entered the Estimate page",
      estimateDetails: this.props.estimateDetails,
      timestamp: new Date().toISOString(),
    });
  }

  componentDidUpdate(pervProps: EstimateProps, prevState: EstimateState) {
    if (
      this.props.isOwnerSubscribed != pervProps.isOwnerSubscribed ||
      this.props.isOwnerExistInStamped != pervProps.isOwnerExistInStamped
    ) {
      this.setState({
        createNewCustomerInStamped: this.props.isOwnerSubscribed,
      });
    }
  }

  openLink(link: string) {
    window.open(link, "_blank");
  }

  render() {
    const isAcceptDeclineButtonsVisible =
      this.common.isEstimateScreenActionRequired(
        this.props.estimateDetails,
        this.props.ibsService.isLinkOpenedFromEmail
      ) && !this.common.isEstimateDeclined(this.props.estimateDetails);
    let status = this.common.getEstimateStatus(
      this.props.estimateDetails,
      this.props.ibsService.isLinkOpenedFromEmail
    );
    return (
      <div>
        <div className="section-wrapper">
          {this.state.showFeedbackScreen ? (
            <>
              <Feedback
                submitFeedback={(values) =>
                  this.setState({ showFeedbackSuccessMessage: true })
                }
                navigateToScreen={(key) => this.props.navigateToScreen(key)}
                ibsService={this.props.ibsService}
                showHideLoader={(value) => this.props.showHideLoader(value)}
                estimateDetails={this.props.estimateDetails}
                showFeedbackScreen={(value: boolean) => {
                  this.setState({ showFeedbackScreen: value });
                  this.props.estimateAccepted();
                }}
              />

              {this.state.showFeedbackSuccessMessage ? (
                <MessageDialog
                  closeCallback={() => this.props.navigateToScreen("home")}
                  icon={<img src={feedbackSuccess} alt="Feedback Success" />}
                  title={"Thank You"}
                  messageText={"Your feedback means a lot to us"}
                  buttons={
                    <button
                      type="button"
                      onClick={() => this.props.navigateToScreen("home")}
                    >
                      Return To Home
                    </button>
                  }
                />
              ) : undefined}
            </>
          ) : (
            <>
              <div className={"headerContainer"}>
                <div className="flex-column">
                  <Heading size="sm" color="blue.700" textAlign={"left"}>
                    Estimate {this.props.estimateDetails.estimateNumber}
                  </Heading>
                  <div className="status">
                    {" "}
                    Status:{" "}
                    <span
                      style={{
                        color:
                          status === "Lost Sale"
                            ? "#E96565"
                            : status === "Pending"
                            ? "#f09a31"
                            : "#48BB78",
                      }}
                    >
                      {status}
                    </span>
                  </div>
                </div>
                {this.props.showAmount && (
                  <Button
                    colorScheme="blue"
                    onClick={() =>
                      this.openLink(
                        this.props.ibsAdonisService.getEstimatePDFUrl(
                          this.props.estimateDetails.estimateId
                        )
                      )
                    }
                  >
                    <HiDownload />
                    <span className="btnText">Download PDF</span>
                  </Button>
                )}
              </div>
              <div className={"clearfix"}></div>
              <Collapsible title="Customer Details" type="main">
                <div>
                  {this.renderFieldRow(
                    "Name",
                    this.props.estimateDetails.ownerName as any
                  )}
                  {this.renderFieldRow(
                    "Email",
                    this.props.estimateDetails.email as any
                  )}
                  {this.renderFieldRow(
                    "Mobile",
                    this.checkNull(this.props.estimateDetails.mobilePhone)
                  )}
                </div>
              </Collapsible>
              <Collapsible title="Vehicle Details" type="main">
                <div>
                  {this.renderFieldRow(
                    "Rego",
                    this.props.estimateDetails.vehicleRegistration
                  )}
                  {this.renderFieldRow("VIN", this.props.estimateDetails.vin)}
                  {this.renderFieldRow(
                    "Year",
                    this.props.estimateDetails?.vehicleManufacturedYear
                  )}
                  {this.renderFieldRow(
                    "Vehicle",
                    this.checkNull(
                      this.props.estimateDetails?.vehicleDescription
                    )
                  )}
                  {this.renderFieldRow(
                    "Body Style",
                    this.props.estimateDetails?.vehicleBody
                      ? this.props.estimateDetails?.vehicleBody
                      : ""
                  )}
                  {this.renderFieldRow(
                    "Paint Code",
                    this.props.estimateDetails?.colourCode
                  )}
                  {this.renderFieldRow(
                    "Odometer",
                    this.props.estimateDetails?.odometer
                      ? this.props.estimateDetails?.odometer
                      : ""
                  )}
                </div>
              </Collapsible>
              <Collapsible title="Estimate" type="main">
                {this.props.estimateDetails?.totals?.primaryEstimatedTotals
                  ?.itemClassTotals &&
                this.props.estimateDetails?.totals?.primaryEstimatedTotals
                  ?.itemClassTotals?.length > 0
                  ? this.props.estimateDetails?.totals?.primaryEstimatedTotals?.itemClassTotals.map(
                      (e) => {
                        let amount = 0;
                        if (e.amount != 0) {
                          amount += 1;
                          return (
                            <Collapsible
                              title={this.getItemClassDisplayName(e.itemClass)}
                              type="subItem"
                              key={amount}
                            >
                              {this.renderListing(e.itemClass as any)}
                              {this.props.showAmount &&
                                this.renderSubTotal(e.amount)}
                            </Collapsible>
                          );
                        }

                        return "";
                      }
                    )
                  : undefined}
              </Collapsible>

              <Box boxShadow={"md"} borderRadius="md" overflow="hidden">
                {this.props.showAmount
                  ? (this.renderSubTotal(
                      this.props.estimateDetails?.totals
                        ?.grandTotalIncludingTax,
                      "Total exc. tax",
                      "subTotal"
                    ),
                    this.renderSubTotal(
                      this.props.estimateDetails?.totals
                        ?.grandTotalIncludingTax -
                        this.props.estimateDetails?.totals
                          ?.grandTotalIncludingTax,
                      "Tax",
                      "subTotal"
                    ),
                    this.renderSubTotal(
                      this.props.estimateDetails?.totals
                        ?.grandTotalIncludingTax,
                      "Grand Total inc. tax",
                      "Total"
                    ))
                  : ""}
              </Box>

              {isAcceptDeclineButtonsVisible &&
              this.props.showAmount &&
              this.props.estimateDetails.primaryDebtorName === "Private"
                ? this.renderAcceptDeclineButtons()
                : null}
              {this.state.videos ? (
                <Collapsible title="Videos" type="main">
                  <div className={"videosContainer"}>
                    <Videos videos={this.state.videos} />
                  </div>
                </Collapsible>
              ) : (
                <></>
              )}
              {this.state.showDeclineMessage ? (
                <DialogMessage
                  closeCallback={() => {
                    this.props.navigateToScreen("home");
                  }}
                  title={"Estimate Declined"}
                  messageText={
                    "We'd love to hear how we can help you next time"
                  }
                  buttons={
                    <>
                      <Button
                        variant="solid"
                        colorScheme="red"
                        onClick={() => {
                          this.setState({
                            showFeedbackScreen: false,
                            showDeclineMessage: false,
                          });
                          this.props.estimateAccepted();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="solid"
                        colorScheme="blue"
                        onClick={() =>
                          this.setState({
                            showFeedbackScreen: true,
                            showDeclineMessage: false,
                          })
                        }
                      >
                        Provide Feedback
                      </Button>
                    </>
                  }
                />
              ) : undefined}
            </>
          )}
        </div>
      </div>
    );
  }

  getItemClassDisplayName(name: string) {
    switch (name) {
      case "RemoveAndRefit":
        return "Remove + Refit";
      case "Other":
        return "Miscellaneous";
      default:
        return name;
    }
  }

  renderListing(type: itemClass) {
    return (
      <table className={"full-width"}>
        <thead>
          <tr>
            <th className={"width50"}>Name</th>
            {this.props.showAmount && (
              <th className={"width50 amount"}>Amount</th>
            )}
          </tr>
        </thead>
        <tbody>
          {this.getLabourRows(type).map((e: any) => (
            <tr key={Math.random().toString()}>
              <td className="title">
                <div>{e.description}</div>
                {e.comment && (
                  <div style={{ fontSize: "10px", color: "#888" }}>
                    ***{e.comment}***
                  </div>
                )}
              </td>
              {this.props.showAmount && (
                <td className={"cost"}>
                  {e.currentValue.totalAmountIncludingMarkup
                    ? "$ " +
                      e.currentValue.totalAmountIncludingMarkup.toFixed(2)
                    : ""}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  getLabourRows(type: string) {
    if (type == "Parts") {
      return this.props.estimateDetails.parts
        ? this.props.estimateDetails.parts
        : [];
    } else if (type == "Other" || type == "Sublet") {
      if (this.props.estimateDetails.other) {
        return this.props.estimateDetails.other.filter(
          (x) => x.presentAsItemClass == type
        );
      }
    } else {
      if (this.props.estimateDetails.labour) {
        return this.props.estimateDetails.labour.filter(
          (x) => x.presentAsItemClass == type
        );
      }
    }
    return [];
  }

  getTotalsObj(type: string): ItemClassTotalsEntity {
    if (
      this.props.estimateDetails?.totals?.primaryEstimatedTotals
        ?.itemClassTotals &&
      this.props.estimateDetails?.totals?.primaryEstimatedTotals
        ?.itemClassTotals?.length > 0
    ) {
      let filtered =
        this.props.estimateDetails?.totals?.primaryEstimatedTotals?.itemClassTotals.filter(
          (x) => x.itemClass == type
        );
      if (filtered.length > 0) return filtered[0];
    }
    return { amount: 0, hours: 0, itemClass: "", percentage: 0 };
  }

  checkNull(data: any) {
    return data ? data : "";
  }

  renderFieldRow(label: string, value: string | number) {
    return (
      <div className={"fieldRow"}>
        <div className={"col"}>
          <div className={"col-sm-4 fieldHeading"}>{label}</div>
          <div className={"col-sm-8 fieldValue"}>{value}</div>
        </div>
      </div>
    );
  }

  renderAcceptDeclineButtons() {
    return (
      <SimpleGrid columns={2} spacing={4} mt={12} mb={12}>
        <Button
          as={GridItem}
          size="lg"
          colorScheme="red"
          variant="outline"
          onClick={() => this.declineEstimate()}
        >
          <AiOutlineClose />
          <span className={"btnText"}>Decline</span>
        </Button>
        <Button
          as={GridItem}
          size="lg"
          colorScheme="green"
          onClick={() => {
            this.acceptEstimate();
          }}
        >
          <AiOutlineCheck />
          <span className={"btnText"}>Accept</span>
        </Button>
      </SimpleGrid>
    );
  }

  renderSubTotal(
    calculatedPrice: number,
    label: string = "Sub Total",
    additionalClass: string = ""
  ) {
    return (
      <div className={["subTotal", additionalClass].join(" ")}>
        {label}: ${calculatedPrice ? calculatedPrice.toFixed(2) : ""}
      </div>
    );
  }

  async acceptEstimate() {
    this.props.showHideLoader(true);
    try {
      const userEmail = this.props?.estimateDetails?.email
        ? this.props?.estimateDetails?.email
        : "";        
      const acceptEstimatePayload = {
        supplementaryNumber: this.getSuppNumber(),
        debtorId:
          this.props.estimateDetails && this.props.estimateDetails.debtorId
            ? this.props.estimateDetails.debtorId
            : "",
        debtorName:
          this.props.estimateDetails &&
          this.props.estimateDetails.primaryDebtorName
            ? this.props.estimateDetails.primaryDebtorName
            : "",
      };

      const isBookingFlow = this.props.estimateDetails.adminCheckList.some(
        (checklistItem: string) =>
          checklistItem.includes(AdminChecklistItems.BOOKING_FLOW)
      );

      this.ibsAdonisService
        .acceptEstimate(
          this.props.estimateDetails.primaryDetailId,
          acceptEstimatePayload
        )
        .then((res) => {
          if (res.ok) {
            res.json().then(async (resJSON: any) => {
              // For updating Booking Flow in Admin Checklist

              try {
                const logsObj = {
                  estimateId: this.props.estimateDetails?.estimateId,
                  actionType: ActionType.AcceptedEstimate,
                };
                await this.ibsAdonisService.insertBulkActionLogs([logsObj]);
              } catch (error) {
                console.log("🚀 ~ Estimate ~ error:", error);
              }

              let isUpdateAdminCheckListSuccessfully = true;
              if (!isBookingFlow) {
                try {
                  const { success }: { success: boolean } =
                    await this.props.ibsAdonisService?.updateAdminChecklist(
                      this.props.estimateDetails?.estimateId,
                      [
                        ...this.props.estimateDetails.adminCheckList,
                        AdminChecklist?.BookingFlow,
                      ]
                    );

                  isUpdateAdminCheckListSuccessfully = success;
                } catch (error) {
                  // Handle unexpected errors
                  console.error(
                    "Unexpected error in updating admin checklist:",
                    error
                  );
                  isUpdateAdminCheckListSuccessfully = false;
                }
              }
              if (
                this.props.estimateDetails.workType === null ||
                this.props.estimateDetails.workType === undefined
              ) {
                const workType = this.commonMethodService.getWorkType(
                  this.props.estimateDetails.totals.totalLabourUnauthorised
                );
                this.props.ibsAdonisService
                  .updateWorkType(
                    this.props.estimateDetails.estimateId,
                    workType
                  )
                  .then(async (workTypeResponse: any) => {
                    if (workTypeResponse.success) {
                      Mixpanel.track("WorkType Updated Success", {
                        userEmail,
                        type: "WorkType Updated",
                        estimateDetail: this.props.estimateDetails,
                        workType,
                      });
                    } else {
                      Mixpanel.track("WorkType Updated Error", {
                        userEmail,
                        type: "WorkType Updated",
                        estimateDetail: this.props.estimateDetails,
                        workType,
                        error: workTypeResponse?.errors,
                      });
                    }
                  });
              }

              let tabCondition = isUpdateAdminCheckListSuccessfully
                ? dashboardTabs.bookingDetail
                : dashboardTabs.estimateDetails;

              if (isBookingFlow) {
                this.notifyService.successNotitifcation(
                  "A confirmation message will be sent to your email shortly."
                );
              }

              Mixpanel.track("Estimate Accepted ", {
                estimateDetail: this.props.estimateDetails,
                response: resJSON,
                status: "Estimate accepted successfully",
              });
              const htmlContent =
                this.commonMethodService.createNotificationTemplate(
                  this.props.estimateDetails,
                  "accepted"
                );
              if (this.props.estimateDetails.jobNumber != 0) {
                this.commonMethodService.setQueryParams(
                  this.props.estimateDetails.estimateNumber,
                  tabCondition
                );
                this.props.navigateToSelectedTab(tabCondition);
                Mixpanel.track("Issue Job", {
                  type: "Job already issued",
                  status: "Navigate to booking tab",
                });
              } else {
                const issueJobResponse: any =
                  await this.props.ibsAdonisService.sendIssueJobRequest(
                    {
                      id: this.props.estimateDetails.estimateId,
                      profileId: "88f194c9-ad9b-4c93-8f31-73c10a627411",
                      profileName: "Insurance/Private",
                      profileVersion: 15,
                    },
                    this.props.ibsService.currentUser?.auth?.token
                  );
                if (issueJobResponse.success) {
                  this.commonMethodService.setQueryParams(
                    this.props.estimateDetails.estimateNumber,
                    tabCondition
                  );
                  this.props.navigateToSelectedTab(tabCondition);
                  Mixpanel.track("Issue Job", {
                    type: "Job issued successfully",
                    status: "Navigate to booking tab",
                  });
                } else {
                  Mixpanel.track("Issue Job Error", {
                    resp: issueJobResponse,
                    type: "Job is not issued",
                    status: "Can't navigate to booking tab",
                  });
                }
              }
              this.ibsAdonisService
                .sendTeamsNotification({
                  message: htmlContent,
                  email: userEmail,
                  note: {
                    message: "Estimate Accepted",
                    estimateId: this.props.estimateDetails.estimateId,
                    title: "Estimate Accepted",
                  },
                  estimateDetails: this.props.estimateDetails,
                })
                .then(async (response) => {
                  if (response?.ok) {
                    Mixpanel.track("Accept Estimate Notification Send", {
                      htmlContent: htmlContent,
                      userEmail,
                      type: "Estimate Accepted",
                      estimateDetail: this.props.estimateDetails,
                      status: "Notification send successfully",
                    });
                  } else {
                    const resp = await response?.json();
                    Mixpanel.track("Accept Estimate Notification Send Error", {
                      htmlContent,
                      userEmail,
                      type: "Estimate Accepted",
                      estimateDetail: this.props.estimateDetails,
                      error: resp,
                      status: "Notification not send",
                    });
                  }
                });
              if (this.state.createNewCustomerInStamped) {
                this.common.createCustomerInStamped(
                  this.props.stampedService,
                  this.props.estimateDetails,
                  this.props.ibsService,
                  this.props.showHideLoader.bind(this)
                );
              } else {
                this.props.showHideLoader(false);
              }

              this.props.estimateAccepted();
            });
          } else {
            this.notifyService.errorNotitifcation(
              "Estimate not accepted, Please try it again"
            );
            Mixpanel.track("Estimate Accepted Error", {
              estimateDetail: this.props.estimateDetails,
              status: "Estimate not accepted",
            });
          }
        });
    } catch (ex) {
      Mixpanel.track("Estimate Accepted Exception Error", {
        estimateDetail: this.props?.estimateDetails,
        status: "Estimate not accepted",
        exception: ex,
      });
      this.props.showHideLoader(false);
    }
  }

  getSuppNumber() {
    if (
      this.props.estimateDetails &&
      this.props.estimateDetails.currentSupplementaryNumber
    ) {
      return this.props.estimateDetails.currentSupplementaryNumber;
    }
    return 0;
  }

  declineEstimate() {
    this.props.showHideLoader(true);
    const userEmail = this.props?.estimateDetails?.email
      ? this.props?.estimateDetails?.email
      : "";
    this.props.ibsAdonisService
      .declineEstimate(this.props.estimateDetails.estimateId)
      .then((res) => {
        if (res.ok) {
          this.props.ibsAdonisService
            .sendEmail(
              "Estimate has been rejected",
              "Job Confirmation - ID: " +
                this.props.estimateDetails.estimateNumber,
              this.props.estimateDetails.estimateId,
              this.props.estimateDetails.estimateNumber.toString()
            )
            .then();
          res.json().then(async (resJSON) => {
            const message =
              "We have already issued a job, Estimate could not be cancelled.";
            if (!resJSON.success) {
              this.notifyService.errorNotitifcation(message);
              Mixpanel.track("Estimate Declined Error", {
                estimateDetail: this.props.estimateDetails,
                response: resJSON,
                status: "Estimate not declined",
              });
            } else {
              Mixpanel.track("Estimate Declined", {
                estimateDetail: this.props.estimateDetails,
                response: resJSON,
                status: "Estimate declined successfully",
              });
              this.setState({ showDeclineMessage: true });
              const htmlContent =
                this.commonMethodService.createNotificationTemplate(
                  this.props.estimateDetails,
                  "declined"
                );
              const response =
                await this.ibsAdonisService.sendTeamsNotification({
                  message: htmlContent,
                  email: userEmail,
                  note: {
                    message: "Estimate Declined",
                    estimateId: this.props.estimateDetails.estimateId,
                    title: "Estimate Declined",
                  },
                  estimateDetails: this.props.estimateDetails,
                });
              if (response?.ok) {
                Mixpanel.track("Declined Estimate Notification Send", {
                  htmlContent: htmlContent,
                  userEmail,
                  type: "Estimate Declined",
                  estimateDetail: this.props.estimateDetails,
                  status: "Notification send successfully",
                });
              } else {
                const resp = await response?.json();
                Mixpanel.track("Declined Estimate Notification Send Error", {
                  htmlContent,
                  userEmail,
                  type: "Estimate Declined",
                  estimateDetail: this.props.estimateDetails,
                  error: resp,
                  status: "Notification not send",
                });
              }
            }
          });
        }
      });

    this.props.showHideLoader(false);
  }
}
